import { withStyles } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';

export const TotDropzoneArea = withStyles(({ palette }) => ({
    dropZone: {
        minHeight: 'unset',
        outlineColor: palette.primary.main,
    },
}))(DropzoneArea);
